import classNames from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import { ReactComponent as IconList } from '../../../../assets/images/list2.svg';
import { ReactComponent as IconLocation } from '../../../../assets/images/map-icon.svg';
import { useMedia } from '../../../context/InterfaceContext';

import './index.scss';

interface IControlViews {
    setToggle: (toggle: boolean) => void;
    toggle: boolean;
}

export type ControlViewsProps = IControlViews;

const ControlViews: FC<ControlViewsProps> = ({ toggle, setToggle }) => {
    const intl = useIntl();
    const { isFullMobile } = useMedia();

    return (
        <div className={classNames('control-views', { ['control-views--active-list']: toggle })}>
            <div className="control-views__list" onClick={() => setToggle(true)}>
                <IconList />
                {!isFullMobile && intl.formatMessage({ id: 'location.list', defaultMessage: 'Liste' })}
            </div>

            <div className="control-views__map" onClick={() => setToggle(false)}>
                <IconLocation />
                {!isFullMobile && intl.formatMessage({ id: 'location.map', defaultMessage: 'Karte' })}
            </div>
        </div>
    );
};

export default ControlViews;
